import axios from '@/axios/fetch';
// import MockPath from '@/mock/mock_api';
import { definitions } from '@/types/api';
import NodeRSA from 'jsencrypt';

export type changePasswordJson = {
  code: string;
  newPassword: string;
  oldPassword: string;
};

const key = new NodeRSA();
// 公钥向后端索取
key.setPublicKey('-----BEGIN RSA PRIVATE KEY-----\n'
        + `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCfmqOtshQkeQ0UkmNqcEvbX9v5ln7CzMOIGsCm
  WSLYVoCo9hVYCGUXbbQX8i0L7gtnNF+LtNgyVHTrmzEjS8EnhHjV8swF3XMK8mk1Z3TszzmHMJbn
  s/F1oItSuO6oF0R3TYy4NGWbjLFnH/U7DycOgZr2dLuiEVrf2PB4Dlnj8wIDAQAB`
        + '-----END RSA PRIVATE KEY-----');
// const mockpath = new MockPath();
class Api {
  VUE_APP_MOCK = process.env.VUE_APP_MOCK === '1';

  /**
   * 登录接口
   * @param data 登录信息
   */
  login = (data: definitions['LoginRequest']) => {
    const path = './api/user/login';
    // if (this.VUE_APP_MOCK) {
    //   path = mockpath.login;
    // }
    return axios.post(path, {
      code: data.code,
      password: key.encrypt(data.password.trim()),
    });
  };

  /**
   * 默认密码
   * @param data 默认密码
   */
   getDefaultPassword = () => axios.post('./api/defaultInfo/getDefaultPassword');

  /**
   * 登录接口
   * @param data 登录信息
   */
  logOut = () => {
    const path = './api/user/logout';
    return axios.post(path, {});
  };

  /**
   * 添加用户
   * @param reqData
   * @returns
   */
  addUser = (reqData: definitions['AddUserRequest']) => axios.post('./api/userHero/addUser', reqData);

  /** 更换头像 */
  updateHeadImag = (reqData: FormData) => axios.post('./api/user/updateHeadImag', reqData)

  /**
   * 获取用户信息
   */
  getByCode = (code: string) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.getByCode :
    './api/user/getByCode', {
      code,
    },
  );

  /**
   * 修改用户信息
   * @param formData 用户信息
   */
  changeUserInfo = (formData: unknown) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.changeUserName :
    './api/user/changeUserInfo', formData,
  );

  /**
   * 班级添加学生&教师
   * @param formData 创建学生&教师
   */
  createClassMember = (formData: unknown) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.createUser : './api/classMember/createClassMember',
    // this.VUE_APP_MOCK ? mockpath.createUser :
    './api/userHero/createClassMember',
    formData,
  );

  /**
   * 查询用户列表
   * @param searchData 查询条件
   */
  queryUserList = (searchData: unknown) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.getUserList :
    './api/user/queryUserList', searchData,
  );

  /**
   * 查询学生列表
   * @param searchData
   */
  queryStudentList = (searchData: unknown) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.getStudentList :
    './api/classMember/listStudent',
    searchData,
  );

  /**
   * 重置用户密码
   * @param BaseUserCodeRequest code
   */
  adminResetPassword = (BaseUserCodeRequest: { code: string }) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.resetPassword :
    './api/user/adminResetPassword',
    BaseUserCodeRequest,
  );

  /**
   * 删除学生
   * @param formData
   */
  delStudent = (formData: unknown) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.delteStudent :
    './api/userManage/delStudent', formData,
  );

  /**
   * 删除教师
   * @param formData
   */
  delTeacher = (formData: unknown) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.delteTeacher :
    './api/userManage/delTeacher', formData,
  );

  /**
   * 更改个人信息
   * @param formData
   */
  changeUserSignature = (formData: unknown) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.changeUserSignatures :
    './api/user/changeUserSignature',
    formData,
  );

  /**
   * 修改密码
   * @param formData
   */
  changePassword = (formData: changePasswordJson) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.changePasswords :
    './api/user/changePassword',
    {
      code: formData.code,
      newPassword: key.encrypt(formData.newPassword.trim()),
      oldPassword: key.encrypt(formData.oldPassword.trim()),
    },
  );

  /**
   * 查询班级列表
   * @param searchData
   */
  getClassList = (searchData: unknown) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.getClassList :
    './api/class/queryClass', searchData,
  );

  /**
   * 编辑&创建班级
   * @param formData
   */
  editClassData = (formData: unknown) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.editClass :
    './api/class/createOrUpdateClass',
    formData,
  );

  /**
   * 删除班级
   * @param formData
   */
  delClass = (formData: unknown) => axios.post(
    // this.VUE_APP_MOCK ? mockpath.delClass :
    './api/userManage/delClass', formData,
  );

  /**
   * 导入学生——没有处理mock
   * @param formData
   * @param classId 班级id
   */
  uploadStudentByClass = (formData: FormData, classId: string) => axios.post(`./api/classMember/insertStudent?classId=${classId}`, formData);

  /**
   * 导入学生——会把异常的返回回来，正常的直接上传
   * @param formData file
   * @param classId 班级id
   */
  uploadStudents = (formData: FormData, classId: string) => axios.post(`./api/upload/uploadStudents?classId=${classId}`, formData);

  /**
   * 根据教师code查询所有实验列表
   * @param pageSize 查询.页大小
   * @param pageNo 查询.页号
   */
   queryAllCustomCase = (pageSize: number, pageNo: number) => axios.post(
     `./api/customCase/queryAllCustomCase?pageSize=${pageSize}&pageNo=${pageNo}`,
   );

   /**
    * 删除实验案例
    * @param id 案例id
    */
   deleteCustomCaseById = (id: string) => axios.post(`./api/customCase/deleteCustomCaseById/${id}`);

   /**
   * 实验信息 新增/修改
   * @param reqData
   */
   editExperiment = (reqData: definitions['Experiment']) => axios.post('./api/experiment/editExperiment', reqData);

  /**
   * 根据教师code查询所有实验列表
   * @param pageSize 查询.页大小
   * @param pageNo 查询.页号
   * @param teacher 分配实验教师
   */
  queryExperimentByTeacher = (pageSize: number, pageNo: number, teacher: string) => axios.post(
    `./api/experiment/queryExperimentByTeacher?pageSize=${pageSize}&pageNo=${pageNo}${teacher === 'admin' ? '' : `&teacher=${teacher}`}`,
  );

  /**
   * 根据实验 Ids 批量删除
   * @param reqData
   */
  deleteExperimentByIds = (reqData: {experimentIds: string[]}) => axios.post('./api/experiment/deleteExperimentByIds', reqData);

  /**
   * 根据案例 Id 查询案例
   * @param id 案例Id
   */
  queryCustomCaseById = (id: string) => axios.post(`./api/customCase/queryCustomCaseById/${id}`);

  /**
   * 上传案例图片
   * @param FormData: { file: fileObj }
   */
  uploadImg = (formData: FormData) => axios.post('./api/customCase/uploadimg', formData);

  /**
   * 编辑、新增案例信息
   * @param CustomCase
   */
  editCustomCase = (customCase: definitions['CustomCase']) => axios.post('./api/customCase/editCustomCase', customCase);

  /**
   * 新增、修改单元实验
   * @param CustomUnitExperiment
   */
  editCustomUnitExperiment = (customUnitExperiment: definitions['CustomUnitExperiment']) => axios.post('./api/customUnitExperiment/edit', customUnitExperiment);

  /**
   * 删除单元实验
   * @param customUnitExperimentId
   */
  delCustomUnitExperiment = (customUnitExperimentId: string) => axios.post(`./api/customUnitExperiment/del/${customUnitExperimentId}`)

  /**
   * 根据案例id查询单元实验
   * @param caseId
   */
  queryCustomUnitExperiment = (caseId: string) => axios.post(`./api/customUnitExperiment/queryByCaseId/${caseId}`);

  /**
   * 查询单元实验结束条件
   * @param caseId
   */
  queryCustomUnitEndCondition = (caseId: string) => axios.post(`./api/customUnitEndCondition/queryByCaseId/${caseId}`);

  /**
   * 新增、修改单元实验结束条件
   * @param CustomUnitEndCondition
   */
  editCustomUnitEndCondition = (condition: definitions['CustomUnitEndCondition']) => axios.post('./api/customUnitEndCondition/edit', condition);

  /**
   * 删除单元实验结束条件
   * @param conditionId
   */
  delCustomUnitEndCondition = (conditionId: string) => axios.post(`./api/customUnitEndCondition/del/${conditionId}`)

  /**
  * 根据案例Id查询角色信息
  * @param caseId 案例id
  */
  queryCustomRoleByCaseId = (caseId: string): Promise<{data: definitions['BaseResponseBody«List«CustomRole»»']}> => axios.post(`./api/customRole/queryByCaseId/${caseId}`)

  /**
   * 案例信息 根据caseId获取案例状态
   * @param caseId 案例id
   */
  getStatusByCaseId = (caseId: string) => axios.post(`./api/customCase/getStatusByCaseId/${caseId}`)

  /**
   * 案例信息 新增/修改案例状态
   * @param data 案例状态对象
   */
  editCustomCaseStatus = (data: definitions['CustomCaseStatus']) => axios.post('./api/customCase/editStatus', data)

  /**
   * 角色信息 新增/修改
   * @param data 角色对象
   */
  editCustomRole = (data: definitions['CustomRole']) => axios.post('./api/customRole/edit', data)

  /**
   * 角色信息 新增/修改 树状
   * @param data 角色对象
   */
  editTreeCustomRole = (data: definitions['CustomRole']) => axios.post('./api/customRole/editTree', data)

  /**
   * 角色信息 根据角色Id查询
   * @param id 角色id
   */
  getCustomRoleById = (id: string) => axios.post(`./api/customRole/getById/${id}`)

  /**
   * 角色信息部门能力 根据Id删除
   * @param id 能力id
   */
  delCustomRoleAbility = (id: string) => axios.post(`./api/customRoleAbility/del/${id}`)

  /**
   * 角色信息部门能力 根据案例Id查询
   * @param caseId 案例id
   */
   queryCustomRoleAbility = (caseId: string) => axios.post(`./api/customRoleAbility/queryByCaseId//${caseId}`)

  /**
   * 角色信息部门队伍 新增/修改
   * @param data 部门队伍
   */
  editCustomRoleTeam = (data: definitions['CustomRoleTeam']) => axios.post('./api/customRoleTeam/edit', data)

  /**
   * 角色信息部门队伍 根据Id删除
   * @param id 队伍id
   */
  delCustomRoleTeam = (id: string) => axios.post(`./api/customRoleTeam/del/${id}`)

  /**
   * 角色信息部门物资 根据Id删除
   * @param id 物资id
   */
  delCustomRoleMaterial = (id: string) => axios.post(`./api/customRoleMaterial/del/${id}`)

  /**
   * 角色信息部门物资 新增/修改
   * @param data 部门物资
   */
  editCustomRoleMaterial = (data: definitions['CustomRoleMaterial']) => axios.post('./api/customRoleMaterial/edit', data)

  /**
   * 角色信息部门物资 根据案例Id查询
   * @param id 部门id
   */
  queryCustomRoleMaterial = (id: string) => axios.post(`./api/customRoleTeam/queryByCaseId/${id}`)

  /**
   * 对话信息 根据案例Id查询
   * @param caseId 案例id
   */
  queryCustomTalkByCaseId = (caseId: string) => axios.post(`./api/customTalk/queryByCaseId/${caseId}`)

  /**
   * 对话信息 根据Id删除
   * @param id 对话id
   */
  delCustomTalk = (id: string) => axios.post(`./api/customTalk/del/${id}`)

  /**
    * 对话信息 批量全量删除
    * @param ids 对话id 数组
    */
  delCustomTalkByIds = (ids: Array<string>) => axios.post('./api/customTalk/batchDelByIds', { ids })

  /**
    * 对话信息 新增/修改
    * @param data 对话
    */
  editCustomTalk = (data: definitions['CustomTalk']) => axios.post('./api/customTalk/edit', data)

  /** =============================案例分析===================== */
  /**
    * 案例分析作业 查询列表
    * @param data page
    */
  listCustomCaseAssignment = (data: {pageNo: number; pageSize: number}) => axios.post(`./api/customCaseAssignment/queryList?pageSize=${data.pageSize}&pageNo=${data.pageNo}`)

  /**
   * 案例分析作业 新增/修改
   * @param data
   */
   editCustomCaseAssignment = (data: definitions['CustomCaseAssignment']) => axios.post('./api/customCaseAssignment/edit', data)

  /**
   * 案例分析作业 id查询作业信息
   * @param id id
   */
  queryCustomCaseAssignmentById = (id: string) => axios.post(`./api/customCaseAssignment/queryByCaseId/${id}`)

  /**
   * 案例分析作业 根据id删除
   * @param id
   */
  delCaseAssignment = (id: string) => axios.post(`./api/customCaseAssignment/del/${id}`)

  // 案例分析-题目模块

  /**
   * 案例分析 题目-模块 list
   * @param assignmentId
   */
  listCustomQuestionModuleByCaId = (assignmentId: string) => axios.post(`./api/customQuestionModule/queryQuestionNumberByAssignmentId/${assignmentId}`)

  /**
   * 案例分析 题目-模块 edit/add
   * @param data
   */
  editCustomQuestionModule = (data: definitions['CustomQuestionModule']) => axios.post('./api/customQuestionModule/edit', data)

  /**
   * 案例分析 题目-模块 dels -ids
   * @param ids
   */
  delCustomQuestionModule = (ids: string[]) => axios.post('./api/customQuestionModule/removeIds', { ids })

  // 案例分析-题目

  /**
   * 案例分析 题目-列表 - 根据题目id和模块id —— 这接口好像没意义
   * @param questionId
   * @param moduleId
   */
  listCustomQuestionByQM = (questionId: string, moduleId: string) => axios.post(`./api/customQuestion/queryByQuIdMoId/${questionId}/${moduleId}`)

  /**
   * 案例分析 题目-列表 - 根据模块id
   * @param moduleId
   */
  listCustomQuestionByMId = (moduleId: string) => axios.post(`./api/customQuestion/queryByModuleId/${moduleId}`)

  /**
   * 案例分析 题目-列表 - 单个查询
   * @param id
   */
  queryCustomQuestionById = (id: string) => axios.post(`./api/customQuestion/queryByCaseId/${id}`)

  /**
   * 案例分析 题目-列表 - 批量删除
   * @param ids string[]
   */
  delCustomQuestionIds = (ids: string[]) => axios.post('./api/customQuestion/delCustomQuestionByIds', { ids })

  /**
   * 案例分析 题目-列表 - edit
   * @param data
   */
  editCustomQuestion = (data: definitions['CustomQuestion']) => axios.post('./api/customQuestion/edit', data)

  /**
   * 案例分析 题目-seq重新排序 - edits
   * @param list
   */
  editsSeqCustomQuestion = (list: []) => axios.post('./api/customQuestion/batchUpdateSeq', list)

  /**
   * 案例分析 题目-模块移动 - edits
   * @param list
   */
  editsModuleIdCustomQuestion = (list: []) => axios.post('./api/customQuestion/batchUpdateModuleId', list)

  /** 案例分析 作业查看 */
  /**
   * 案例分析 作业查看 - save（分配作业）
   * @param data
   */
  saveAssignHomework = (data: definitions['AssignHomework']) => axios.post('./api/AssignHomework/saveAssignHomework', data)

  /**
   * 案例分析 作业查看 - list
   * @param data
   */
  listAssignHomework = (data: FormData) => axios.post('./api/AssignHomework/queryList', data)

  /**
   * 案例分析 作业查看 - del
   * @param id
   */
  delAssignHomeworkById = (id: string) => axios.post(`./api/AssignHomework/del/${id}`)

  /**
   * 案例分析 作业查看 - 单个查询
   * @param id
   */
  queryAssignHomeworkById = (id: string) => axios.post(`./api/AssignHomework/getById/${id}`)

  /**
   * 案例分析 作业查看 - 分配记录对应的学生列表
   * @param data
   */
  listAssignHomeworkPersonnel = (data: definitions['QueryPersonnelByAssignIdRequest']) => axios.post('./api/assignHomeworkPersonnel/queryListByAssignId', data)

  /**
   * 案例分析 发布作业
   */
  savePublishStates = (id: string) => axios.post(`./api/AssignHomework/updatePublishStatesById/${id}`)
}

export default new Api();
